import React from 'react'

const HighlightedText = ({text}) => {
  return (
    <div className='text-blue-400'>
        {text}
    </div>
  )
}

export default HighlightedText